import React from 'react'
import { Route, Switch } from 'react-router'
import { GetMessage } from './pages/GetMessage'

export const MessageRouterV2 = () => (
  <Switch>
    <Route exact path={`/message/:id`} component={GetMessage} />
  </Switch>
)
